<template>
  <div class="header">
    <a href="https://nordenhospital.com" target="_blank">
      <img src="./assets/imagens/logo@2x.png" />
    </a>
    <p v-if="sessaoValida" class="medico"></p>
  </div>

  <transition name="fade">
    <div v-if="!sessaoValida" class="divisor">
      <div></div>
      <div></div>
    </div>
  </transition>

  <transition name="fade">
    <div v-if="!sessaoValida" class="container">
      <!-- Frase de boas vindas. -->
      <div class="frase-boas-vindas">
        <p>
          Olá, bem vindo(a) à sua consulta com o(a) {{ profissional.nome }}.
        </p>
      </div>

      <div class="orientacao">
        <!-- Câmera -->
        <div class="camera">
          <video></video>
          <img
            v-if="!this.dispositivos[1].ligado"
            :class="{ carregando: carregando }"
            src="./assets/imagens/sem-camera@2x.png"
          />
        </div>

        <div class="tela-config">
          <!-- Configuração de câmera e microfone -->
          <div class="configuracao">
            <div>
              <label>{{ dispositivos[0].tipo }}</label>
              <label class="switch">
                <input
                  type="checkbox"
                  @click="mudarEstadoDispositivo(dispositivos[0].tipo)"
                />
                <span class="slider round">
                  <img
                    v-if="!dispositivos[0].ligado"
                    src="./assets/imagens/sem-microfone.png"
                  />
                  <img
                    v-else
                    :class="{ ativo: dispositivos[0].ligado }"
                    src="./assets/imagens/com-microfone.png"
                  />
                </span>
              </label>
            </div>
            <div>
              <label>{{ dispositivos[1].tipo }}</label>
              <label class="switch">
                <input
                  type="checkbox"
                  @click="mudarEstadoDispositivo(dispositivos[1].tipo)"
                />
                <span class="slider round">
                  <img
                    v-if="!dispositivos[1].ligado"
                    src="./assets/imagens/sem-camera.png"
                  />
                  <img
                    v-else
                    :class="{ ativo: dispositivos[1].ligado }"
                    src="./assets/imagens/com-camera.png"
                  />
                </span>
              </label>
            </div>
          </div>

          <!-- Nome e sobrenome do(a) paciente -->
          <div class="paciente">
            <label>NOME E SOBRENOME</label><br />
            <input type="text" placeholder="Insira seu nome e sobrenome" />
          </div>

          <!-- Botão -->
          <div>
            <button class="botao-entrar" @click="entrarConsulta">
              ENTRAR NA CONSULTA
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <!-- <transition name="fade">
    <div v-if="nomeInvalido && podeConfig" class="caixa-aviso">
      <p>Nome inválido. Por favor, insira seu nome antes de entrar na consulta.</p>
    </div>
  </transition> -->

  <transition name="fade">
    <MaisInfos v-if="!sessaoValida" />
  </transition>
</template>

<script>
import MaisInfos from "./components/MaisInfos.vue";
import { useHead } from "@vueuse/head";
import WiseAPI from "wise-api";

export default {
  name: "App",
  components: {
    MaisInfos,
  },
  data() {
    return {
      idSessao: null,
      nomeInvalido: false,
      sessaoValida: false,
      podeConfig: false,
      carregando: true,
      profissional: {
        nome: "",
      },
      dispositivos: [
        {
          tipo: "MICROFONE",
          ligado: false,
          texto: "OFF",
          srcOn: require("./assets/imagens/com-microfone.png"),
          srcOff: require("./assets/imagens/sem-microfone.png"),
        },
        {
          tipo: "CÂMERA",
          ligado: false,
          texto: "OFF",
          scrOn: require("./assets/imagens/com-camera.png"),
          scrOff: require("./assets/imagens/sem-camera.png"),
        },
      ],
    };
  },
  // Para mais informações sobre "setup()":
  // https://v3.vuejs.org/guide/composition-api-introduction.html#setup-component-option
  setup() {
    useHead({
      title: "Consulta Telemedicina",
      link: [
        {
          href: "https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js",
        },
      ],
    });
  },
  async mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.idSessao = urlParams.get("sessao");

    if (!this.idSessao) {
      this.carregando = false;
      return;
    }

    const resposta = await this.obterProfissional(this.idSessao);
    const fraseBoasVindas =
      document.getElementsByClassName("frase-boas-vindas")[0];

    if (!resposta.ok) {
      fraseBoasVindas.firstChild.textContent =
        "Esta sala não existe. Por favor, verifique sua URL.";
    } else {
      this.profissional.nome = resposta.name;

      this.configMutationObserver();

      const botaoEntrar = document.querySelector("button");
      botaoEntrar.style.cssText = "opacity: 1; cursor: pointer;";
      this.podeConfig = true;
    }

    fraseBoasVindas.style.opacity = "1";
    this.carregando = false;
  },
  methods: {
    configMutationObserver() {
      const observador = new MutationObserver((mutations) => {
        if (mutations) {
          // Podemos usar o método "Array.from()" também.
          const iFrameV4H = [...mutations[0].addedNodes].find(
            (node) =>
              node.id === "jitsiConferenceFrame0" || node.tagName === "IFRAME"
          );

          if (iFrameV4H) {
            const divTelemed = document.getElementById("telemedicina");
            const divComprimento = divTelemed.clientWidth;
            iFrameV4H.style.width = divComprimento + "px";
            iFrameV4H.style.height = "100%";
          }
        }
      });

      const opcoesObservador = { childList: true, subtree: true };
      observador.observe(document.body, opcoesObservador);
    },
    alertaNomeValido() {
      const inputPaciente = document.getElementsByClassName("paciente")[0];
      const nomePaciente = inputPaciente.lastChild.value;

      if (nomePaciente.length > 1) return true;

      if (this.podeConfig) {
        inputPaciente.lastChild.style.border = "1px solid #EE8484";
        this.nomeInvalido = true;
        setTimeout(() => {
          inputPaciente.lastChild.style.border = "";
          this.nomeInvalido = false;
        }, 3000);
        return false;
      }
    },
    nomePac() {
      const inputPaciente = document.getElementsByClassName("paciente")[0];
      const nomePaciente = inputPaciente.lastChild.value;
      return nomePaciente;
    },
    ilustrarProfissional(profissional) {
      const medico = document.getElementsByClassName("medico")[0];
      const nome = profissional.nome;
      medico.textContent = `Consulta com ${nome}`;
      setTimeout(() => (medico.style.opacity = "1"), 500);
    },
    async obterProfissional(idSessao) {
      const reqUrl = process.env.VUE_APP_NORDEN_URL + idSessao;
      const reqOpcoes = { method: "GET" };
      const req = await fetch(reqUrl, reqOpcoes);

      if (req.ok) {
        const _json = await req.json();
        _json.ok = req.ok;
        return _json;
      }

      return req;
    },
    mudarEstadoDispositivo(tipo) {
      const index = tipo === "MICROFONE" ? 0 : 1;
      this.dispositivos[index].ligado = !this.dispositivos[index].ligado;
      this.dispositivos[index].texto = this.dispositivos[index].ligado
        ? "ON"
        : "OFF";

      if (tipo === "CÂMERA") {
        this.mudarEstadoCamera();
      } else {
        this.mudarEstadoMicrofone();
      }
    },
    async mudarEstadoCamera() {
      if (!navigator.mediaDevices && !navigator.mediaDevices.getUserMedia) {
        alert("Não é possível usar a câmera.");
        return;
      }

      const video = document.querySelector("video");
      const cameraLigada = this.dispositivos[1].ligado;
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      }, function(stream) {
        stream.getTracks().forEach(track => track.stop())
      });

      if (cameraLigada) {
        video.srcObject = mediaStream;
        video.play();
      } else {
        video.srcObject = null;
        video.pause();
        mediaStream.getVideoTracks().forEach(track => {
          track.enabled = false;
          track.stop();
        })
      }
    },
    async mudarEstadoMicrofone() {
      if (!navigator.mediaDevices && !navigator.mediaDevices.getUserMedia) {
        alert("Não é possível usar o microfone.");
        return;
      }

      const microfone = this.dispositivos[0];
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      window.localStream = microfone.ligado ? stream : null;
      //window.localAudio.srcObject = microfone.ligado ? stream : null;
    },
    mensagemFinal() {
      document.getElementById("telemedicina").remove();
      document.getElementById("preenchimento").remove();
      document.getElementsByClassName("medico")[0].remove();

      const divFinal = document.createElement("div");
      const msgFinal = document.createElement("p");

      msgFinal.textContent =
        "Basta fechar esta aba para sair do ambiente de telemedicina. Até logo!";
      msgFinal.style.fontSize = "3vh";

      divFinal.appendChild(msgFinal);

      divFinal.style.display = "flex";
      divFinal.style.justifyContent = "center";
      divFinal.style.alignItems = "center";
      divFinal.style.height = "70%";

      document.getElementById("app").appendChild(divFinal);
    },
    async entrarConsulta() {
      if (this.carregando) return;

      const nomePaciente = this.alertaNomeValido();

      if (!nomePaciente || !this.profissional.nome || !this.idSessao) return;

      this.sessaoValida = true;

      const divTelemedicina = document.createElement("div");
      divTelemedicina.id = "telemedicina";
      divTelemedicina.style.height = "88%";

      const app = document.getElementById("app");
      app.appendChild(divTelemedicina);

      const v4h = new WiseAPI();

      v4h.setup({
        baseUrl: process.env.VUE_APP_V4H_URL,
        login: process.env.VUE_APP_V4H_USER,
        senha: process.env.VUE_APP_V4H_PW,
      });

      const options = {
        parentNode: divTelemedicina,
        startWithAudioMuted: !this.dispositivos[0].ligado,
        startWithVideoMuted: !this.dispositivos[1].ligado,
        userInfo: { displayName: this.nomePac() },
        //userInfo: { displayName: this.nomePac() },
        shareLink: process.env.VUE_APP_SHARE_URL + this.idSessao,
        buttons: [
          "microphone",
          "camera",
          "closedcaptions",
          "desktop",
          "fullscreen",
          "fodeviceselection",
          "hangup",
          "profile",
          "info",
          "chat",
          "recording",
          "livestreaming",
          "etherpad",
          "sharedvideo",
          "settings",
          "raisehand",
          "videoquality",
          "filmstrip",
          "invite",
          "feedback",
        ],
        onClose: this.mensagemFinal,
      };

      await v4h.room.open(this.idSessao);

      const infoToJoin = await v4h.room.join(this.idSessao);

      await v4h.session.startConference(infoToJoin.sessionId, options);
      this.ilustrarProfissional(this.profissional);

      const header = document.getElementsByClassName("header")[0];
      const body = document.body.clientHeight;
      const alturaHeader = header.clientHeight;
      const alturaTelemed = divTelemedicina.clientHeight;
      const alturaPreenchimento = body - (alturaTelemed + alturaHeader);
      const divPreenchimento = document.createElement("div");
      divPreenchimento.id = "preenchimento";
      divPreenchimento.style.height = alturaPreenchimento + "px";
      divPreenchimento.style.backgroundColor = "rgb(242, 233, 213)";
      app.appendChild(divPreenchimento);
    },
  },
};
</script>

<style>
/**
  * @license
  * MyFonts Webfont Build ID 4004832, 2021-01-31T20:02:39-0500
  *
  * The fonts listed in this notice are subject to the End User License
  * Agreement(s) entered into by the website owner. All other parties are
  * explicitly restricted from using the Licensed Webfonts(s).
  *
  * You may obtain a valid license at the URLs below.
  *
  * Webfont: Glence-Black by Nine Font
  * URL: https://www.myfonts.com/fonts/nine-font/glence/black/
  *
  * Webfont: Glence-Bold by Nine Font
  * URL: https://www.myfonts.com/fonts/nine-font/glence/bold/
  *
  * Webfont: Glence-ExtraBold by Nine Font
  * URL: https://www.myfonts.com/fonts/nine-font/glence/extra-bold/
  *
  * Webfont: Glence-Heavy by Nine Font
  * URL: https://www.myfonts.com/fonts/nine-font/glence/heavy/
  *
  * Webfont: Glence-Light by Nine Font
  * URL: https://www.myfonts.com/fonts/nine-font/glence/light/
  *
  * Webfont: Glence-Medium by Nine Font
  * URL: https://www.myfonts.com/fonts/nine-font/glence/medium/
  *
  * Webfont: Glence-Regular by Nine Font
  * URL: https://www.myfonts.com/fonts/nine-font/glence/regular/
  *
  *
  * Webfonts copyright: Copyright (c) 2017 by Nine Font. All rights reserved.
  *
  * © 2021 MyFonts Inc
  */

/* @import must be at top of file, otherwise CSS will not work */
@import url("https://hello.myfonts.net/count/3d1be0");

@font-face {
  font-family: "Glence";
  font-weight: 1000;
  font-display: block;
  src: url("./assets/fontes/Glence-Black.woff2") format("woff2"),
    url("./assets/fontes/Glence-Black.woff") format("woff");
}

@font-face {
  font-family: "Glence";
  font-weight: 400;
  font-display: block;
  src: url("./assets/fontes/Glence-Regular.woff2") format("woff2"),
    url("./assets/fontes/Glence-Regular.woff") format("woff");
}

@font-face {
  font-family: "Glence";
  font-weight: 900;
  font-display: block;
  src: url("./assets/fontes/Glence-Heavy.woff2") format("woff2"),
    url("./assets/fontes/Glence-Heavy.woff") format("woff");
}

@font-face {
  font-family: "Glence";
  font-weight: 800;
  font-display: block;
  src: url("./assets/fontes/Glence-ExtraBold.woff2") format("woff2"),
    url("./assets/fontes/Glence-ExtraBold.woff") format("woff");
}

@font-face {
  font-family: "Glence";
  font-weight: 700;
  font-display: block;
  src: url("./assets/fontes/Glence-Bold.woff2") format("woff2"),
    url("./assets/fontes/Glence-Bold.woff") format("woff");
}

@font-face {
  font-family: "Glence";
  font-weight: 300;
  font-display: block;
  src: url("./assets/fontes/Glence-Light.woff2") format("woff2"),
    url("./assets/fontes/Glence-Light.woff") format("woff");
}

@font-face {
  font-family: "Glence";
  font-weight: 500;
  font-display: block;
  src: url("./assets/fontes/Glence-Medium.woff2") format("woff2"),
    url("./assets/fontes/Glence-Medium.woff") format("woff");
}

/* 
  <body> looks to its parent (<html>) for how to 
  scale the dynamic property, so the HTML element 
  needs to have its height set as well.  
*/
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Glence, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2b2b2b;
}

/* - - - - - - - - - - - - - - - - - - - - - -
 *                                            |
 *                .CLASSES                    |
 *                                            |
 - - - - - - - - - - - - - - - - - - - - - - */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 27px 120px 24px 120px;
  background-color: #f2e9d5;
  height: 100px;
}

.header img {
  height: 40px;
}

.header p {
  font-size: 20px;
  margin-left: 25px;
  text-align: right;
}

.divisor {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50.01%, -50%);
  -ms-transform: translate(-50%, -50%);
  transition: opacity 1s;
  z-index: -1;
}

.divisor div:first-child {
  flex-grow: 2;
  max-height: 67%;
  background-color: #f2e9d5;
}

.divisor div:last-child {
  flex-grow: 1;
  background-color: #fcfdff;
}

.medico {
  opacity: 0;
  transition: opacity 2s;
}

.container {
  display: flex;
  flex-direction: column;
  /* min-width: 420px; */
  max-width: 420px;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  transition: opacity 1s;
}

/* <div> do botão de entrar na sala */
.container div:last-child {
  background-color: #f7f9fc;
}

.orientacao {
  display: flex;
  flex-direction: column;
}

.tela-config {
  display: flex;
  flex-direction: column;
  border: none;
  box-shadow: 0px 2px 10px #d5d5d2;
  border-radius: 5px;
}

.container .frase-boas-vindas {
  text-align: center;
  margin: 0 -40px;
  opacity: 0;
  transition: opacity 1s;
}

.container .frase-boas-vindas p {
  word-wrap: break-word;
  font-size: 24px;
  letter-spacing: 2px;
  margin-bottom: 16px;
}

.container .camera {
  flex-grow: 2;
  height: 316px;
  background-color: #162442;
  border-bottom: 2px solid #e7e7e7;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  position: relative;
}

.container .camera img {
  height: 35px;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.container .camera video {
  height: 100%;
  width: 100%;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.container .configuracao {
  display: flex;
  align-content: center;
  height: 50px;
  font-size: 10px;
  letter-spacing: 1px;
  font-weight: bold;
}

.container .configuracao div {
  width: 70px;
  margin-right: 33px;
}

.container .configuracao div:last-child {
  background-color: #f7f9fc;
}

.container .paciente,
.container .configuracao {
  flex-grow: 1;
  background-color: #f7f9fc;
  border-bottom: 2px solid #e7e7e7;
  padding: 18px;
}

.container .paciente {
  margin: 0;
}

.container .paciente label {
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}

.container .paciente input {
  /* color: #B4B4B3; */
  border: none;
  border-radius: 5px;
  box-shadow: 2px 2px 5px #d5d5d2;
  margin-top: 10px;
  font-size: 17px;
  padding-left: 20px;
  box-sizing: border-box;
  height: 55px;
  width: 100%;
}

.container .paciente input:focus {
  outline: none;
}

.container .paciente input:focus::placeholder {
  color: transparent;
}

.container .tela-config > div:last-child {
  padding: 18px;
}

.container .botao-entrar {
  flex-grow: 1;
  height: 55px;
  width: 100%;
  box-shadow: 2px 2px 5px #d5d5d2;
  background-color: #b48c46;
  border-radius: 5px;
  border: none;

  font-size: 16px;
  letter-spacing: 1px;
  color: #ffffff;
  opacity: 0.5;
  transition: opacity 1s;
}

.caixa-aviso {
  position: fixed;
  bottom: 27%;
  right: 50%;
  -ms-transform: translate(50%, -50%);
  transform: translate(50%, -50%);
  width: 450px;
  background-color: #ee8484;
  border-radius: 5px;
  padding: 0 0 0 25px;
  font-size: 17px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 
 * Retirado de "How TO - Toggle Switch" 
 * (Disponível em: https://www.w3schools.com/howto/howto_css_switch.asp) 
 */

.switch {
  position: relative;
  display: inline-block;
  width: 63px;
  height: 29px;
  margin-top: 10px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ee8484;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 3px;
  background-color: #ffffff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider.round {
  border-radius: 35px;
}

.slider.round img {
  color: #ffffff;
  height: 20px;
  position: absolute;
  top: 50%;
  right: 0;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.slider.round img.ativo {
  left: 0;
  -ms-transform: translate(50%, -50%);
  transform: translate(50%, -50%);
}

.slider.round:before {
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #8ad4a2;
}

input:focus + .slider {
  box-shadow: 0 0 1px #8ad4a2;
}

input:checked + .slider:before {
  -webkit-transform: translateX(33px);
  -ms-transform: translateX(33px);
  transform: translateX(33px);
}

/* - - - - - - - - - - - - - - - - - - - - - -
 *                                            |
 *                 @MEDIAS                    |
 *                                            |
 - - - - - - - - - - - - - - - - - - - - - - */

/* @media screen 
  and (max-width: 320px)
  and (orientation : landscape) {

  .orientacao {
    flex-direction: row;
    width: 35vw;
    transform: scale(0.1);
  }

  .header img {
    height: 25px;
  }

  .container {
    align-items: center;
  }

  .container .orientacao .camera {
    height: unset;
  }

  .container .frase-boas-vindas {
    margin: 0;
  }

  .container .frase-boas-vindas p {
    font-size: 16px;
    font-weight: 400;
  }

  .container .paciente input {
    font-size: 13px;
  }
  
  .container .botao-entrar {
    font-size: 13px;
  }
} */

@media screen and (max-width: 320px) {
  #telemedicina {
    height: 86% !important;
  }

  .header {
    height: 80px;
    padding-left: 16px;
    padding-top: 24px;
  }

  .header img {
    height: 30px;
  }

  .header p {
    display: none;
  }

  .container {
    min-width: 272px !important;
  }

  .container .frase-boas-vindas {
    margin: 0;
  }

  .container .frase-boas-vindas p {
    font-size: 16px;
    margin: 0 0 16px 0;
  }

  .container .camera {
    height: 26vh;
  }

  .container .paciente input,
  .container .botao-entrar {
    font-size: 13px;
  }

  .container .paciente input,
  .container .botao-entrar {
    height: 35px;
  }
}

/* @media screen 
  and (min-width: 321px)
  and (max-width: 375px)
  and (orientation : landscape) {

  .orientacao {
    flex-direction: row;
    width: 55vw;
    box-shadow: 0px 2px 10px #D5D5D2;
  }

  .header img {
    height: 25px;
  }

  .container {
    align-items: center;
  }

  .container .frase-boas-vindas {
    margin: 0;
  }

  .container .frase-boas-vindas p {
    font-size: 16px;
    font-weight: 400;
  }

  .container .configuracao,
  .container .paciente label {
    font-size: 13px;
  }

  .container .paciente input {
    font-size: 14px;
  }
  
  .container .botao-entrar {
    font-size: 13px;
  }

  .container,
  .container .camera {
    border-top-right-radius: 0px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    height: fit-content
  }
} */

@media screen and (min-width: 321px) and (max-width: 375px) {
  #telemedicina {
    height: 86% !important;
  }

  .header {
    height: 80px;
    padding-left: 16px;
    padding-top: 24px;
  }

  .header img {
    height: 30px;
  }

  .header p {
    display: none;
  }

  .container {
    min-width: 320px !important;
  }

  .container .frase-boas-vindas {
    margin: 0;
  }

  .container .frase-boas-vindas p {
    font-size: 16px;
    margin: 0 0 16px 0;
  }

  .container .camera {
    height: 20vh;
  }

  .container .paciente input,
  .container .botao-entrar {
    font-size: 13px;
  }

  .container .paciente input,
  .container .botao-entrar {
    height: 35px;
  }
}

@media screen and (min-width: 376px) and (max-width: 425px) and (orientation: landscape) {
  .orientacao {
    flex-direction: row;
    width: 55vw;
  }

  .header img {
    height: 25px;
  }

  .container {
    align-items: center;
  }

  .container .orientacao .camera {
    height: unset;
  }

  .container .frase-boas-vindas {
    margin: 0;
  }

  .container .frase-boas-vindas p {
    font-size: 16px;
    font-weight: 400;
  }

  /* div.paciente input { */
  .container .paciente input {
    font-size: 13px;
  }

  .container .botao-entrar {
    font-size: 13px;
  }
}

@media screen and (min-width: 376px) and (max-width: 425px) {
  #telemedicina {
    height: 86% !important;
  }

  .header {
    height: 80px;
    padding-left: 16px;
    padding-top: 24px !important;
  }

  .header img {
    height: 30px;
  }

  .header p {
    display: none;
  }

  .container {
    min-width: 370px !important;
  }

  .container .frase-boas-vindas {
    margin: 0;
  }

  .container .frase-boas-vindas p {
    font-size: 16px;
    margin: 0 0 16px 0;
  }

  .container .camera {
    height: 20vh;
  }

  .container .paciente {
    height: fit-content;
  }

  .container .paciente input,
  .container .botao-entrar {
    font-size: 14px;
  }

  .container .paciente input,
  .container .botao-entrar {
    height: 35px;
  }
}

@media screen and (min-width: 426px) and (max-width: 768px) and (orientation: landscape) {
  .header {
    padding: 27px 22px 24px 22px;
  }

  .header p {
    font-size: 14px;
  }

  .orientacao {
    flex-direction: row;
    width: 55vw;
    box-shadow: 0px 2px 10px #d5d5d2;
  }

  .header img {
    height: 25px;
  }

  .container {
    align-items: center;
    -ms-transform: translate(-50%, -46%);
    transform: translate(-50%, -46%);
  }

  .container .orientacao .camera {
    height: unset;
  }

  .container .frase-boas-vindas {
    margin: 0;
  }

  .container .frase-boas-vindas p {
    font-size: 14px;
    font-weight: 400;
    margin: 0 0 4px 0;
  }

  .container .orientacao .tela-config {
    box-shadow: 0px 0px 0px #d5d5d2;
  }

  .container,
  .container .camera {
    border-top-right-radius: 0px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    height: fit-content;
  }

  .container .configuracao {
    height: fit-content;
    font-size: 9px;
  }

  .container .paciente {
    height: fit-content;
  }

  .container .paciente label {
    font-size: 9px;
  }

  .container .paciente input {
    font-size: 13px;
    height: 35px;
  }

  .container .botao-entrar {
    font-size: 13px;
    height: 30px;
  }

  .switch {
    height: 25px;
  }

  .slider:before {
    height: 19px;
    width: 19px;
    left: 4px;
    bottom: 3px;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(36px);
    -ms-transform: translateX(36px);
    transform: translateX(36px);
  }
}

@media screen and (min-width: 426px) and (max-width: 768px) {
  .header {
    height: 80px;
    padding-left: 16px;
    padding-top: 24px;
  }

  .header p {
    display: none;
  }

  .container .frase-boas-vindas {
    margin: 0;
  }

  .container .camera {
    height: 20vh;
  }
}

@media screen and (min-width: 769px) and (max-width: 1100px) and (orientation: landscape) {
  .orientacao {
    flex-direction: row;
  }

  .header {
    padding: 27px 22px 24px 22px;
  }

  .header img {
    height: 25px;
  }

  .container {
    align-items: center;
  }

  .container .orientacao .camera {
    height: unset;
  }

  .container .frase-boas-vindas {
    margin: 0;
  }

  .container .frase-boas-vindas p {
    font-size: 14px;
    font-weight: 400;
  }

  /* div.paciente input { */
  .container .paciente input {
    font-size: 13px;
    height: 35px;
  }

  .container .botao-entrar {
    font-size: 13px;
    height: 35px;
  }
}

@media screen and (min-width: 769px) and (max-width: 1100px) {
  .container .camera {
    height: 20vh;
  }
}

@media screen and (min-width: 1101px) and (max-width: 1366px) {
  .container {
    max-width: 290px;
  }

  .container .frase-boas-vindas p {
    font-size: 16px;
    margin: 0 0 16px 0;
  }

  .container .camera {
    height: 186px;
  }

  .container .paciente,
  .container .configuracao {
    height: fit-content;
  }

  .container .paciente label,
  .container .configuracao {
    font-size: 9px;
  }

  .container .paciente input {
    height: 50px;
    font-size: 13px;
  }

  .container .botao-entrar {
    height: 35px;
    font-size: 13px;
  }

  .switch {
    height: 25px;
  }

  .slider:before {
    height: 19px;
    width: 19px;
    left: 4px;
    bottom: 3px;
  }

  .slider.round img {
    height: 18px;
    top: 50%;
    right: 2px;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .slider.round img.ativo {
    left: 2px;
    top: 50%;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(36px);
    -ms-transform: translateX(36px);
    transform: translateX(36px);
  }
}
</style>
